import { useContext } from 'react'

// Context
import { ShareVersionContext } from '../../../modules/versioning'

import { useGetPagePresentationFileQuery } from '@sketch/gql-types'
import { getRenderStatus } from '@sketch/modules-common'

interface UseCanvasPresentationFileProps {
  pageUUID: string
}

const SKETCH_MODEL_WITH_FRAMES = 156

export const useCanvasPresentationFile = ({
  pageUUID,
}: UseCanvasPresentationFileProps) => {
  const shareVersionContext = useContext(ShareVersionContext)!
  const { versionShortId, share, loading } = shareVersionContext

  const renderStatus = !loading
    ? getRenderStatus(
        shareVersionContext.currentVersion.document?.renderStatus ?? null
      )
    : null

  const shouldSkipQuery = shareVersionContext.loading
    ? true
    : shareVersionContext?.currentVersion?.presentationStatus === 'PENDING'

  const prFileQuery = useGetPagePresentationFileQuery({
    variables: {
      shareIdentifier: share.identifier,
      versionShortId,
      pageUUID,
    },
    skip: shouldSkipQuery,
  })

  const page = prFileQuery.data?.share?.version?.document?.page
  const isLoading = prFileQuery.loading
  const hasError = prFileQuery.error
  const isRendering = renderStatus !== 'ready'

  const currentDocumentVersion = shareVersionContext.loading
    ? 0
    : shareVersionContext.currentVersion.document?.documentVersion || 0

  const showArtboardDecorations =
    currentDocumentVersion < SKETCH_MODEL_WITH_FRAMES

  return {
    share,
    page,
    versionShortId,
    isLoading,
    hasError,
    isRendering,
    showArtboardDecorations,
  }
}
